(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bcr-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bcr-slider')) {
    customElements.define('bcr-slider', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.bcr-hero__slide')];
        if (this.slides.length < 2) return;
        this.dots = [...this.querySelectorAll('.bcr-hero__dot')];
        this.i = 0;
        this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.i - 1));
        this.querySelector('[data-next]').addEventListener('click', () => this.go(this.i + 1));
        this.dots.forEach((d, n) => d.addEventListener('click', () => this.go(n)));
        let x = null;
        this.addEventListener('touchstart', (e) => { x = e.touches[0].clientX; }, { passive: true });
        this.addEventListener('touchend', (e) => {
          if (x === null) return;
          const dx = e.changedTouches[0].clientX - x;
          if (Math.abs(dx) > 50) this.go(this.i + (dx < 0 ? 1 : -1));
          x = null;
        });
        this.ms = (parseInt(this.dataset.speed, 10) || 6) * 1000;
        const design = window.Shopify && window.Shopify.designMode;
        this.auto = this.dataset.autoplay === 'true' && !design && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.auto) {
          this.play();
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.play());
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) this.play(); });
          this.onVis = () => (document.hidden ? this.stop() : this.play());
          document.addEventListener('visibilitychange', this.onVis);
        }
        this.addEventListener('shopify:block:select', (e) => {
          const n = this.slides.indexOf(e.target);
          if (n > -1) { this.stop(); this.go(n); }
        });
      }
      play() { this.stop(); this.t = setInterval(() => this.go(this.i + 1), this.ms); }
      stop() { clearInterval(this.t); }
      go(n) {
        const len = this.slides.length;
        n = (n + len) % len;
        this.slides.forEach((s, k) => {
          const on = k === n;
          s.classList.toggle('is-active', on);
          s.toggleAttribute('inert', !on);
          if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        });
        this.dots.forEach((d, k) => d.setAttribute('aria-current', k === n ? 'true' : 'false'));
        this.i = n;
      }
      disconnectedCallback() {
        this.stop();
        if (this.onVis) document.removeEventListener('visibilitychange', this.onVis);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bcr-product-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bcr-tabs')) {
    customElements.define('bcr-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role=tab]')];
        this.tabs.forEach((t, i) => {
          t.addEventListener('click', () => this.select(i));
          t.addEventListener('keydown', (e) => {
            let n = null;
            if (e.key === 'ArrowRight') n = (i + 1) % this.tabs.length;
            if (e.key === 'ArrowLeft') n = (i - 1 + this.tabs.length) % this.tabs.length;
            if (e.key === 'Home') n = 0;
            if (e.key === 'End') n = this.tabs.length - 1;
            if (n !== null) { e.preventDefault(); this.select(n); this.tabs[n].focus(); }
          });
        });
        this.addEventListener('shopify:block:select', (e) => {
          const n = this.tabs.indexOf(e.target);
          if (n > -1) this.select(n);
        });
      }
      select(i) {
        this.tabs.forEach((t, k) => {
          const on = k === i;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          const p = document.getElementById(t.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
